import * as React from 'react';
import { RelatoriosCompartilhado } from '../../pages/publica/relatorios-compartilhado';
import { BaSeLoadingPage } from '@base/react';
import { LayoutPublic } from '../layouts/layout';

export const PublicRoutes = [
  {
    routePath: '/publico/relatorio/:link',
    isExactPath: true,
    pageToRender: (
      <React.Suspense fallback={<BaSeLoadingPage />}>
        <LayoutPublic>
          <RelatoriosCompartilhado />
        </LayoutPublic>
      </React.Suspense>
    ),
  },
];
